import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import Cookies from 'js-cookie';
import Price from './price/price';

const Hero:React.FC<any> =  () => {
  const navigate = useNavigate();
  const handleMoreSubscribe = () => {
  
    ReactPixel.fbq('trackCustom', 'clickCTA_hometap', {
          "content_name": 'clickCTA_hometap',
          "content_category": 'click',
          "city": "KR",
          "gender" : "female"
        })

    setTimeout(() => {
      // window.location.href = "https://flutterphotypeta.page.link/H2PN";
      window.location.href = "https://photyp.onelink.me/Vchx/4t4hhz9e";
    }, 300);
  }



  const handleGotoKakaoInqurie = () => {
    window.location.href = 'http://pf.kakao.com/_eiGQK';
  }


  return (
    <Container>
      <ImgContainer>
        <Img src="images/klikkie/main/landingTop5_1.png"/>
        <Img src="images/klikkie/main/additional1.png"/>
      </ImgContainer>
      <IntquireContainer>
        <InquireText onClick={handleGotoKakaoInqurie}>
          <Label>대량 인화 문의하기</Label>
          <ArrowContainer>
            <ArrowImg src="images/klikkie/main/inquireArrow.png" alt="arrow" />
          </ArrowContainer>
        </InquireText>
      </IntquireContainer>
      <ImgContainer>
        <Img src="images/klikkie/main/additional2.png"/>
        <Img src="images/klikkie/main/landingTop6_1.png"/>
      </ImgContainer>
    <CircularButtonWrapper
      className="top"
        onClick={handleMoreSubscribe}
      >
        <TooltipWrapper>
              12개월 구독권 20% 할인 ・ 10장 업그레이드
            <TooltipArrow/>
            </TooltipWrapper>
      <CircularButton className='top'>
        앱에서 <span>무료체험부터</span> 신청하기
      </CircularButton>
    </CircularButtonWrapper>
    <ImgContainer>
      <Img src="images/klikkie/main/smart_2.png"/>
    </ImgContainer>
    {/* <Price /> */}
  </Container>
  )
};

export default Hero;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 2000px;
  background-color: #F0EADF;
`;

const CircularButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  width: 90%;
  height: 54px;
  position: relative;

  &.top {
    margin: 50px auto 70px;
  }

`;

const CircularButton = styled.button`
  width: 100%;
  height: 100%;
  border-radius: 30px;
  /* background-color: #e1a349; */
  
  /* font-weight: bold; */
  color: #fff;

  &.top {
    background-color: black;
  }

  &.bottom {
    background-color: #18B2BB;
  }

  span {
    font-weight: bold;
  }
`;

const ImgContainer = styled.div`
  width: 100%;

  &.phone {
    width: 90%;
  }

  &.bottom {
    margin-bottom: 50px;
  }
`;

const Img = styled.img`
  width: 100%;
`;

const TooltipWrapper = styled.div`
  position: absolute;
  bottom: 90%; // 버튼 위에 위치
  left: 50%;
  transform: translateX(-50%); 
  background-color: #58CD57;
  /* color: white; */
  color: white;
  padding: 5px 12px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -1.0px;
  white-space: nowrap;
  opacity: 1; /* 항상 보이도록 설정 */
  visibility: visible;
  z-index: 1000;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #58CD57;
`;

const IntquireContainer = styled.div`
  width: 100%;
  /* height: 50px; */
  background-color: #F0EADF;
  /* background-color: yellow; */
  display: flex;
  margin-bottom: 80px;
`

const InquireText = styled.div`
  /* width: 100%; */
  border: none;
  outline: none;

  display: flex;
  margin: 0 auto;
  justify-content: center;
   /* ✅ 가로 중앙 정렬 (텍스트+화살표 묶음) */

  font-size: 16px;
  font-family: 'Pretendard';
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;

  transition: background-color 0.15s ease, transform 0.1s ease;
`;

const Label = styled.span`
  color: #797979;
  margin-right: 20px;          /* ✅ 글자 뒤 여백 */
`;

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ArrowImg = styled.img`
  width: 0.8em;                 /* ✅ 글자 크기(18px)와 동일 */
  height: 0.8em;
  object-fit: contain;
`;